/**
 * Detect errors caused by stale dynamically-imported chunks after a deployment.
 *
 * Browsers throw different error messages depending on the engine:
 * - Chrome/Edge: "Failed to fetch dynamically imported module: <url>"
 * - Firefox: "error loading dynamically imported module: <url>"
 * - Safari: "Importing a module script failed."
 */
export function isStaleChunkError(type: string | undefined, value: string | undefined): boolean {
  if (!value) return false;
  const lower = value.toLowerCase();
  return (
    (type === 'TypeError' || type === 'Error') &&
    (lower.includes('failed to fetch dynamically imported module') ||
      lower.includes('error loading dynamically imported module') ||
      lower.includes('importing a module script failed'))
  );
}
